import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { ArrowRight } from "lucide-react";
import CustomButton from "./Buttons";

const CustomCardII = ({
  image,
  title,
  subtitleI,
  subtitleII,
  subtitleIII,
  clickFun = () => { },
  direction = "rtl",
  buttonTitle = "",
  buttonClassName = "",
  isEdit = false,
  tooltip = "",
  emission = "--",
}) => {
  const theme = useTheme();

  return (
    <Card
      sx={{ boxShadow: "none", borderRadius: "10px" }}
      className="border-2 cursor-pointer"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: direction === "rtl" ? "row-reverse" : "row",
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "column", width: "60%" }}
          className="py-3"
        >
          <CardContent sx={{ flex: "1 0 auto" }}>
            <div className="flex gap-2 text-[17px] font-bold text-gray-900 mb-1">
              {title}
            </div>
            <div className="text-[13px] font-medium text-gray-500">{subtitleI}</div>
            <div className="text-[13px] font-medium text-gray-500">
              {subtitleII}
            </div>
            <div className="text-[13px] font-medium text-gray-500">
              {subtitleIII}
            </div>
          </CardContent>
        </Box>
        <CardMedia
          component="img"
          sx={{ width: 151, width: "40%" }}
          image={image}
          alt={`${title} album cover`}
        />
      </Box>
      <div className="w-full flex justify-center px-6 py-4 border-t">
        <div className={isEdit ? "flex items-center pr-5" : "hidden"}>
          <span className="font-medium pr-1 whitespace-nowrap">{emission > 0 ? emission : "--"}</span>
          <span>tCO<sub>2</sub>e</span>
        </div>
        <CustomButton
          type="button"
          className={buttonClassName}
          click={() => {
            clickFun();
          }}
          text={buttonTitle}
          tooltip={tooltip}
        />
      </div>
    </Card>
  );
};

export default CustomCardII;
